import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    api
      .get("/auth/me")
      .then((r) => mounted && setUser(r.data))
      .catch(() => mounted && setUser(false));
    return () => (mounted = false);
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      // Two-step OTP flow: return a pending-otp state instead of a user
      if (data && data.otp_required) {
        return { pendingOtp: true, ...data };
      }
      setUser(data);
      return { pendingOtp: false, user: data };
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
      return { pendingOtp: false, error: true };
    }
  };

  const verifyLoginOtp = async (login_token, otp) => {
    setError("");
    try {
      const { data } = await api.post("/auth/verify-otp", { login_token, otp });
      setUser(data);
      return { success: true, user: data };
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
      return { success: false };
    }
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, verifyLoginOtp, logout, error }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
